import { styled } from '@mui/material/styles';
import { Box, Table, TableCell, TableRow, Typography, IconButton } from '@mui/material';

export const BORDER_RADIUS = 8;
export const BORDER_COLOR = '#737F86';
export const ROW_BG = '#FFF';
export const HEADER_BG = '#2F736E';
export const HEADER_TEXT = '#F6F8F9';
export const HEADER_BORDER = '#737F86';
export const COLLAPSED_HEADER_BG = '#1B5E5A';

export const ScrollContainer = styled(Box)({
  width: '100%',
  height: '100%',
  overflow: 'auto',
});

export const StyledTableContainer = styled(Box)({
  minWidth: 600,
  marginBottom: '12px',
});

export const StyledTable = styled(Table)({
  borderCollapse: 'separate',
  borderSpacing: '0',
});

export const RowHeaderCell = styled(TableCell)({
  backgroundColor: HEADER_BG,
  color: HEADER_TEXT,
  fontWeight: 700,
  fontSize: '0.875rem',
  lineHeight: '1rem',
  borderTopLeftRadius: BORDER_RADIUS,
  WebkitBorderBottomLeftRadius: BORDER_RADIUS,
  borderRight: `1px solid ${HEADER_BORDER}`,
  borderBottom: 'none',
  position: 'sticky',
  top: 0,
  left: 0,
  zIndex: 5,
});

export const ParentGroupCell = styled(TableCell)({
  backgroundColor: HEADER_BG,
  color: HEADER_TEXT,
  fontWeight: 700,
  fontSize: '0.75rem',
  lineHeight: '1rem',
  borderBottom: `1px solid ${HEADER_BORDER}`,
  padding: 8,
  position: 'sticky',
  top: 0,
  zIndex: 3,
});

export const ParentGroupContent = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-start',
  fontSize: '1rem',
  gap: 8,
});

export const ToggleButton = styled(IconButton)({
  color: '#9AD6D1',
  '&:hover': {
    backgroundColor: 'transparent',
  },
});

export const ChildHeaderCell = styled(TableCell)({
  backgroundColor: HEADER_BG,
  color: HEADER_TEXT,
  fontWeight: 700,
  fontSize: '0.75rem',
  lineHeight: '1rem',
  borderBottom: 'none',
  position: 'sticky',
  zIndex: 2,
  height: '26px',
  padding: '0 8px 0 0',
  minWidth: '80px',
  textAlign: 'right',
});

export const CollapsedHeaderCell = styled(TableCell)({
  backgroundColor: COLLAPSED_HEADER_BG,
  color: HEADER_TEXT,
  fontWeight: 700,
  fontSize: '0.75rem',
  lineHeight: '1rem',
  borderBottom: 'none',
  position: 'sticky',
  zIndex: 2,
  height: '26px',
  padding: '0 8px 0 0',
  minWidth: '80px',
  textAlign: 'right',
});

export const DataRow = styled(TableRow)({
  backgroundColor: ROW_BG,
});

const baseDataCellStyles = {
  fontSize: '0.875rem',
  lineHeight: '1rem',
  paddingTop: '0.75rem',
  paddingBottom: '0.75rem',
  paddingLeft: '0.5rem',
  border: `1px solid ${BORDER_COLOR}`,
} as const;

export const RowHeaderDataCell = styled(TableCell)({
  ...baseDataCellStyles,
  color: '#1B1C17',
  fontWeight: 700,
  backgroundColor: ROW_BG,
  position: 'sticky',
  left: 0,
  zIndex: 1,
});

export const DataCell = styled(TableCell)({
  ...baseDataCellStyles,
  color: '#162936',
  backgroundColor: ROW_BG,
  fontWeight: 500,
  textAlign: 'right',
});

export const CollapsedDataCell = styled(TableCell)({
  ...baseDataCellStyles,
  color: '#162936',
  backgroundColor: '#E8E8E8',
  fontWeight: 500,
  textAlign: 'right',
});

export const SectionSpacerCell = styled(TableCell)({
  border: 'none',
  padding: 0,
  background: 'transparent',
  position: 'sticky',
  left: 0,
  zIndex: 1,
});

export const SectionTitle = styled(Typography)({
  color: '#1B1C17',
  fontWeight: 700,
  fontSize: '0.875rem',
  lineHeight: '1rem',
});
